import { ReactNode } from 'react';
import { hintClass, labelClass } from './formStyles';

interface FormFieldProps {
  label: string;
  required?: boolean;
  hint?: string;
  className?: string;
  children: ReactNode;
}

export const FormField = ({
  label,
  required,
  hint,
  className = '',
  children,
}: FormFieldProps) => (
  <div className={className}>
    <label className={labelClass}>
      {label}
      {required ? ' *' : ''}
    </label>
    {children}
    <p className={hintClass}>{hint || '\u00A0'}</p>
  </div>
);
